import { ref, watch } from '@nuxtjs/composition-api'

import PricedCar from '@/classes/PricedCar'
import UserFirebase from '@/classes/UserFirebase'
import { ClickedCar, pushCardLog, pushSearchCarLog, updateLogClickedCars } from '@/modules/logger'
import ggoApi from '@/modules/ggo-api'

export default function () {
  /** 最近一次新增的那筆找車 log 在 Firebase 上的 key */
  const logKey = ref<string | null>(null)
  /** 目前找車 log 已點擊的車輛列表 */
  const clickedCars = ref<ClickedCar[]>([])

  /** 取得用戶詳細資料 */
  const getUserDetail = async () => {
    const { data } = await ggoApi.getUserProfile()
    return data
  }

  /** 向 Firebase 新增一筆 search log 並取得該 log 在 Firebase 的 key */
  const addSearchLog = async (getCount: () => Promise<number | null>) => {
    const timerStart = Number(new Date())

    const count = await getCount()

    const user = await getUserDetail()

    const duration = Number(new Date()) - timerStart

    if (count != null) {
      let userDetail
      if (user) {
        userDetail = new UserFirebase(user)
        logKey.value = await pushSearchCarLog({ userDetail, count, duration })
      } else {
        logKey.value = await pushSearchCarLog({ userDetail, count, duration })
      }
    }
  }

  /** 綁定信用卡的 log */
  const addCardLog = async (success: boolean, price?: number, message?: string) => {
    const timerStart = Number(new Date())

    const user = await getUserDetail()

    if (user) {
      const duration = Number(new Date()) - timerStart

      const userDetail = new UserFirebase(user)
      logKey.value = await pushCardLog({ userDetail, success, duration, price, message })
    }
  }

  /** 點擊車輛 */
  const clickCar = (car: PricedCar) => {
    if (car instanceof PricedCar) {
      clickedCars.value.push({
        id: car.id,
        price: Number(car.price),
      })
    }
  }

  watch(logKey, () => { clickedCars.value = [] })

  watch(clickedCars, (list) => {
    if (logKey.value) updateLogClickedCars(logKey.value, list)
  })

  return {
    logKey,
    clickedCars,
    addSearchLog,
    addCardLog,
    clickCar,
    getUserDetail,
  }
}
